var config = {
  "fields": {
    "id": {
      "name": "id",
      "type": "ID",
      "readonly": 3,
      "options": null
    },
    "name": {
      "name": "name",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "status": {
      "name": "status",
      "type": "BOOL",
      "readonly": false,
      "options": null
    },
    "featureFlowSize": {
      "name": "featureFlowSize",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "sidebarSize": {
      "name": "sidebarSize",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "commentPageSize": {
      "name": "commentPageSize",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "termsVersion": {
      "name": "termsVersion",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "fallbackSkinId": {
      "name": "fallbackSkinId",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "analytics": {
      "name": "analytics",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "mediaDocumentId": {
      "name": "mediaDocumentId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "impressumDocumentId": {
      "name": "impressumDocumentId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "termsDocumentId": {
      "name": "termsDocumentId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "cookieDocumentId": {
      "name": "cookieDocumentId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "gdprDocumentId": {
      "name": "gdprDocumentId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "helpDocumentId": {
      "name": "helpDocumentId",
      "type": "ID",
      "readonly": false,
      "options": null
    }
  },
  "attachments": [],
  "relations": []
};
export default config;